// extracted by mini-css-extract-plugin
module.exports = {"ButtonContainer":"sidebar_ButtonContainer__svv9Z","smallButton":"sidebar_smallButton__rsE_Y","topMarging":"sidebar_topMarging___Ny8D"};